import React from 'react';

import { useWebUiGlobalContext } from './context/global/use-global-context';
import './index.scss';
import WebUiLayout from './layout';
import WebUiDashboardPage from './pages/dashboard-page';
import WebUiLicensesPage from './pages/licenses-page';
import WebUiLoginPage from './pages/login-page';
import WebUiMaintenanceFwupdatePage from './pages/maintenance/maintenance-fwupdate-page';
import WebUiMaintenanceSettingsPage from './pages/maintenance/maintenance-settings-page';
import WebUiMaintenanceUsersPage from './pages/maintenance/maintenance-users-page';
import WebUiMaintenanceWebserverPage from './pages/maintenance/maintenance-webserver-page';
import WebUiSettingsDhcpInserterPage from './pages/settings/settings-dhcp-inserter-page';
import WebUiSettingsDhcpRelayPage from './pages/settings/settings-dhcp-relay-page';
import WebUiSettingsDhcpServerPage from './pages/settings/settings-dhcp-server-page';
import WebUiSettingsIgnitionPage from './pages/settings/settings-ignition-page';
import WebUiSettingsInterfacesPage from './pages/settings/settings-interfaces-page';
import WebUiSettingsLacpPage from './pages/settings/settings-lacp-page';
import WebUiSettingsLldpPage from './pages/settings/settings-lldp-page';
import WebUiSettingsMirroringPage from './pages/settings/settings-mirroring-page';
import WebUiSettingsMqttPage from './pages/settings/settings-mqtt-page';
import WebUiSettingsMulticastPage from './pages/settings/settings-multicast-page';
import WebUiSettingsNatPage from './pages/settings/settings-nat-page';
import WebUiSettingsNtpPage from './pages/settings/settings-ntp-page';
import WebUiSettingsPoePage from './pages/settings/settings-poe-page';
import WebUiSettingsPortsPage from './pages/settings/settings-ports-page';
import WebUiSettingsQosPage from './pages/settings/settings-qos-page';
import WebUiSettingsRemoteLoggingPage from './pages/settings/settings-remote-logging-page';
import WebUiSettingsSnmpPage from './pages/settings/settings-snmp-page';
import WebUiSettingsStpPage from './pages/settings/settings-stp-page';
import WebUiSettingsSystemPage from './pages/settings/settings-system-page/settings-system-page';
import WebUiSettingsVlanPage from './pages/settings/settings-vlan-page';
import WebUiStatusDhcpClientPage from './pages/status/status-dhcp-client-page';
import WebUiStatusDhcpLeasesPage from './pages/status/status-dhcp-leases-page';
import WebUiStatusIgnitionPage from './pages/status/status-ignition-page';
import WebUiStatusInterfacesPage from './pages/status/status-interfaces-page';
import WebUiStatusLacpPage from './pages/status/status-lacp-page';
import WebUiStatusLldpPage from './pages/status/status-lldp-page';
import WebUiStatusLogPage from './pages/status/status-log-page';
import WebUiStatusPoePage from './pages/status/status-poe-page';
import WebUiStatusStpPage from './pages/status/status-stp-page';
import WebUiStatusSystemPage from './pages/status/status-system-page';
import WebUiStatusTrafficPage from './pages/status/status-traffic-page';
import WebUiAccessDenied from './WebUiAccessDenied';

export default function WebUi() {
  const { currentPage, currentUser } = useWebUiGlobalContext();

  if (currentPage.accessError) {
    return <WebUiAccessDenied error={currentPage.accessError} />;
  }

  if (!currentUser) {
    return (
      <WebUiLoginPage
        onSuccess={() => {
          window.location.reload();
        }}
      />
    );
  }

  const { route } = currentPage;

  if (route === 'login') {
    return null;
  }

  const content = (() => {
    if (route === 'dashboard') return <WebUiDashboardPage />;
    // Status
    if (route === 'status_system') return <WebUiStatusSystemPage />;
    if (route === 'status_interfaces') return <WebUiStatusInterfacesPage />;
    if (route === 'status_traffic') return <WebUiStatusTrafficPage />;
    if (route === 'status_poe') return <WebUiStatusPoePage />;
    if (route === 'status_lacp') return <WebUiStatusLacpPage />;
    if (route === 'status_dhcp') return <WebUiStatusDhcpLeasesPage />;
    if (route === 'status_log') return <WebUiStatusLogPage />;
    if (route === 'status_ignition') return <WebUiStatusIgnitionPage />;
    if (route === 'status_stp') return <WebUiStatusStpPage />;
    if (route === 'status_dhcp_client') return <WebUiStatusDhcpClientPage />;
    if (route === 'status_lldp') return <WebUiStatusLldpPage />;

    // Settings
    if (route === 'settings_system') return <WebUiSettingsSystemPage />;
    if (route === 'settings_ignition') return <WebUiSettingsIgnitionPage />;
    if (route === 'settings_ports') return <WebUiSettingsPortsPage />;
    if (route === 'settings_lacp') return <WebUiSettingsLacpPage />;
    if (route === 'settings_vlan') return <WebUiSettingsVlanPage />;
    if (route === 'settings_multicast') return <WebUiSettingsMulticastPage />;
    if (route === 'settings_interfaces') return <WebUiSettingsInterfacesPage />;
    if (route === 'settings_qos') return <WebUiSettingsQosPage />;
    if (route === 'settings_mirroring') return <WebUiSettingsMirroringPage />;
    if (route === 'settings_lldp') return <WebUiSettingsLldpPage />;
    if (route === 'settings_stp') return <WebUiSettingsStpPage />;
    if (route === 'settings_dhcp_server')
      return <WebUiSettingsDhcpServerPage />;
    if (route === 'settings_dhcp_relay') return <WebUiSettingsDhcpRelayPage />;
    if (route === 'settings_dhcp_inserter')
      return <WebUiSettingsDhcpInserterPage />;
    if (route === 'settings_poe') return <WebUiSettingsPoePage />;
    if (route === 'settings_ntp') return <WebUiSettingsNtpPage />;
    if (route === 'settings_remote_logging')
      return <WebUiSettingsRemoteLoggingPage />;
    if (route === 'settings_snmp') return <WebUiSettingsSnmpPage />;
    if (route === 'settings_nat') return <WebUiSettingsNatPage />;
    if (route === 'settings_mqtt') return <WebUiSettingsMqttPage />;

    // Maintenance
    if (route === 'maintenance_users') return <WebUiMaintenanceUsersPage />;
    if (route === 'maintenance_settings')
      return <WebUiMaintenanceSettingsPage />;
    if (route === 'maintenance_webserver')
      return <WebUiMaintenanceWebserverPage />;
    if (route === 'maintenance_fwupdate')
      return <WebUiMaintenanceFwupdatePage />;

    // Third Party Notices
    if (route === 'licenses') return <WebUiLicensesPage />;

    return <div className="px-3 py-2 text-[12px]">Page is not available.</div>;
  })();

  return <WebUiLayout>{content}</WebUiLayout>;
}
